import { adminRoutes } from 'modules/admin/routes/constants';

export const storeOrdersRoutes = {
  root: `${adminRoutes.root}/store`,
  items: `${adminRoutes.root}/store/items`,
};
